var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 10,
    viewBox: "0 0 29 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2401_2153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 9L11.1707 0H13L11.8658 9H10Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9L11.5 0H13L11.8658 9H10Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.378947C19.5425 0.189473 18.8105 0 17.8954 0C15.6078 0 13.9608 1.18421 13.9608 2.88948C13.9608 4.16841 15.1046 4.83157 16.0196 5.25788C16.9347 5.6842 17.2091 5.96842 17.2091 6.34736C17.2091 6.91578 16.4771 7.19999 15.8366 7.19999C14.9216 7.19999 14.4183 7.05789 13.6405 6.72632L13.3203 6.58422L13 8.5263C13.549 8.76316 14.5556 9 15.6078 9C18.0327 9 19.6339 7.8158 19.6339 6.01579C19.6339 5.02105 19.0392 4.26316 17.6667 3.64736C16.8431 3.22104 16.3399 2.98421 16.3399 2.55789C16.3399 2.17895 16.7516 1.8 17.6667 1.8C18.4445 1.8 18.9935 1.9421 19.4053 2.13158L19.6339 2.22631L20 0.378947Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.378947C19.5425 0.189473 18.8105 0 17.8954 0C15.6078 0 14.3725 1.18421 14.3725 2.88948C14.3725 4.16841 15.1046 4.83157 16.0196 5.25788C16.9347 5.6842 17.2091 5.96842 17.2091 6.34736C17.2091 6.91578 16.4771 7.19999 15.8366 7.19999C14.9216 7.19999 14.4183 7.05789 13.6405 6.72632L13.3203 6.58422L13 8.5263C13.549 8.76316 14.5556 9 15.6078 9C18.0327 9 19.6339 7.8158 19.6339 6.01579C19.6339 5.02105 19.0392 4.26316 17.6667 3.64736C16.8431 3.22104 16.3399 2.98421 16.3399 2.55789C16.3399 2.17895 16.7516 1.8 17.6667 1.8C18.4445 1.8 18.9935 1.9421 19.4053 2.13158L19.6339 2.22631L20 0.378947Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4395 0C23.912 0 23.5164 0.0500011 23.2967 0.65L20 9H22.3736L22.8132 7.49999H25.6264L25.89 9H28L26.1538 0H24.4395ZM23.4285 6.00001C23.5603 5.55 24.3077 3.35 24.3077 3.35C24.3077 3.35 24.4834 2.8 24.6154 2.44999L24.7472 3.29999C24.7472 3.29999 25.1868 5.55 25.2747 6.04999H23.4285V6.00001Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9669 0C24.4395 0 24.0438 0.0500011 23.8242 0.65L20 9H22.3736L22.8132 7.49999H25.6264L25.89 9H28L26.1538 0H24.9669ZM23.4285 6.00001C23.6043 5.49999 24.3077 3.35 24.3077 3.35C24.3077 3.35 24.4834 2.8 24.6154 2.44999L24.7472 3.29999C24.7472 3.29999 25.1868 5.55 25.2747 6.04999H23.4285V6.00001Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 6.25L5.11112 4.95C4.71111 3.45001 3.42221 1.8 2 0.999999L4 9H6.4L10 0H7.60001L5.33333 6.25Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 0L-0.597014 0.0999997C2.26865 0.849999 4.23881 2.74999 5 5L4.19403 0.749999C4.05972 0.149998 3.65672 0 3.16418 0H-1Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 0C1.86568 0.757576 4.23881 2.72728 5 5L4.23881 1.41414C4.10448 0.808082 3.65672 0.454546 3.16418 0.454546L-1 0Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 0C1.86568 0.757576 4.23881 2.72728 5 5L4.46269 3.03031C4.32836 2.42425 4.14925 1.81818 3.52239 1.56566L-1 0Z",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9L10.3137 7L10 9H12Z",
    fill: "#051244"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2401_2153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7a4d5028a6db3f6454300207bc865b0b.svg";
export { ForwardRef as ReactComponent };